import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from 'reactstrap';

import './Login.css'
import UserSessionService from '../../services/UserSessionService'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToastHelper from "utils/ToastHelper";
import SFXButtonComponent from "../../components/SFXButtonComponent";

class Login extends Component {

  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      mobile: this.isMobile() // on mobile we swap the SFX logo above the Login components
    };

    this.handleResize = this.handleResize.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.isMobile = this.isMobile.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  validateForm() {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = function (event) {
    event.preventDefault();
    this.setState({isLoading: true});
    let self = this;

    UserSessionService.login(this.state.username, this.state.password).then(function (response) {
      if (response === "passwordExpired") {
        self.props.userHasAuthenticated(true);

        self.props.history.push("/update-password");
      } else if (response === "Forbidden") {
        ToastHelper.error("Maximum number of authentication attempts exceeded, please retry later.");
      } else if (response) {
        self.props.userHasAuthenticated(true);
      } else {
        ToastHelper.error("Incorrect Username or Password");
        self.setState({isLoading: false, password: ""});
      }
    });
  }

  isMobile() {
    return window.innerWidth < 575;
  }

  handleResize() {
    if (window) {
      this.setState({mobile: this.isMobile()});
    }
  }

  componentWillMount() {
    if (window) window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    if (window) window.removeEventListener('resize', this.handleResize);
  }


  render() {

    let LoginStyle = {
      fontSize: '7vw'
    };

    let SignInStyle = {
      fontSize: '3vw'
    };

    let head = <Col>
      <div className="LoginContainer">
        <h1>Login</h1>
        <p className="text-muted">Sign In to your account</p>
      </div>
    </Col>


    const logo = (divClass, imgClass) => <Col className={divClass}><img className={imgClass}
                                                                        src={"/assets/img/ria-logo.png"}
                                                                        alt=""/></Col>;

    let first = '';
    let second = '';

    if (this.state.mobile) {

      second =
        <Col><img className="logo pull-right" src={"/assets/img/ria-logo.png"} alt="" width="auto" height="auto"/></Col>;
      first =
        <Col><h1 style={LoginStyle}>Login</h1><p className="text-muted" style={SignInStyle}>Sign In to your account</p>
        </Col>;
    } else {
      first = head;
      second = logo('', 'logo pull-right');
    }

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-2">
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <Row>
                        {first}
                        {second}
                      </Row>
                      <main>
                        <ToastContainer position="top-right" autoClose={5000} style={{zIndex: 1999}}/>
                      </main>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder="Username"
                               autoComplete="username"
                               id="username"
                               autoFocus
                               onChange={this.handleChange}
                               value={this.state.username}/>
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="password" placeholder="Password"
                               id="password"
                               autoComplete="current-password"
                               onChange={this.handleChange}
                               value={this.state.password}/>
                      </InputGroup>
                      <Row>
                        <Col xs="6">
                          <SFXButtonComponent color="success" className="px-4"
                                              disabled={!this.validateForm()}
                          >Login</SFXButtonComponent>
                        </Col>
                        <Col xs="6" className="text-right">
                          <a href={"/forgot-password"} style={{color: "#FF8C32FF"}} color="link" className="px-0">Forgot
                            password?</a>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Login/Login.js